module.exports = __webpack_public_path__ + "assets/images/BBD20.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/BBD20.png
// module id = 1311
// module chunks = 1